<template>
  <div class="page-content">
    <page-template ref="salesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date';

  export default {
    mixins: [date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '',
              prop: 'otherName',
              type: 'input',
              ifFuzzy: true,
              placeholder: "请输入业务单号"
            }
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "单号",
              type: "input",
              prop: "orderNo",
              span: 12,
              placeholder: "业务单号"
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              isHasAll: true,
              span: 12,
              change: this.getBrandSupplierChange,
              defaultValue: this.$utils.getSysUser().storeId,
              url: api.system.seStore,
            },
            {
              label: "供应商",
              type: "select",
              prop: "supplierId",
              data: [],
              span: 12,
              // url: api.archives.supplier,
              // param: {type: 20},
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              type: 'select',
              span: 12,
              defaultValue: 20,
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '打印',
            code: 'print',
            filter: () => {
              return false
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
            // {label: '供应商编码', prop: 'supplierCode', width: '150', align: 'center'},
            {label: '供应商名称', prop: 'supplierName', width: '190', align: 'center'},
            {label: '销售金额', prop: 'saleAmount', width: '120', align: 'center'},
            {label: '单据金额', prop: 'payAmount', width: '120', align: 'center'},
            {
              label: '状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('wlWholesaleOrder.reviewerStatus')
            },
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center',},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center',},
            {label: '备注', prop: 'remarks', width: '120', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.settle.jointBill
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: '门店',
              prop: 'storeName',
            },
            {
              label: '供应商',
              prop: 'supplierName',
            },
            {
              label: '开始日期',
              prop: 'startDttm',
            },
            {
              label: '结束日期',
              prop: 'endDttm',
            },

            {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            stJointBillMapMVOList: {
              url: api.settle.jointBillMap + "/page",
              indexShow: true,
              height: this.detailHeight,
              showSummary: true,
              tableName: "stJointBillMapMVOList",
              summaryColumns: ['goodsNum', 'saleAmount', 'shareNum', 'payAmount'],
              columns: [
                {
                  label: '商品条码',
                  prop: 'goodsBarCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "价格",
                  prop: "retailPrice",
                  width: '90',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsNum',
                  align: "center",
                },
                {
                  label: '销售金额',
                  width: '90',
                  prop: 'saleAmount',
                  align: "center",
                },
                {
                  label: '扣率',
                  width: '90',
                  prop: 'discountRate',
                  align: "center",
                },
                {
                  label: '销售日期',
                  width: '125',
                  prop: 'saleDttm',
                  align: "center"
                },
                {
                  label: '分成金额',
                  width: '125',
                  prop: 'shareNum',
                  align: "center"
                },
                {
                  label: '应付金额',
                  width: '125',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            stJointBillMapMVOList: {
              tableName: 'stJointBillMapMVOList',
              showSummary: true,
              summaryColumns: ['goodsNum', 'saleAmount', 'shareNum', 'payAmount'],
              columns: [
                {
                  label: '商品条码',
                  prop: 'goodsBarCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "价格",
                  prop: "retailPrice",
                  width: '90',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsNum',
                  align: "center",
                },
                {
                  label: '销售金额',
                  width: '90',
                  prop: 'saleAmount',
                  align: "center",
                },
                {
                  label: '扣率',
                  width: '90',
                  prop: 'discountRate',
                  align: "center",
                },
                {
                  label: '销售日期',
                  width: '125',
                  prop: 'saleDttm',
                  align: "center"
                },
                {
                  label: '分成金额',
                  width: '125',
                  prop: 'shareNum',
                  align: "center"
                },
                {
                  label: '应付金额',
                  width: '125',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.jointBill
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.storeDefault()
    },
    methods: {
      storeDefault() {
        if (this.$utils.getSysUser().storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'storeId')[0].disabled = true;
        }
      },
      getBrandSupplierChange(form) {
        form.supplierId = '';
        form.type = 20;
        this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = [];
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {
          storeId: form.storeId,
          type: form.type
        }).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/bill/joint/detail?id=' + row.id,
          query: {redirect: '/bill/joint'}
        }).catch(err => {
        });
      },
      toEditPage(row) {
        this.$router.push({path: '/bill/joint/add?id=' + row.id}).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/bill/joint/add'});
      },
      goodsDetailExport() {
        let selectData = this.$refs["salesTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["salesTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.wholesale.salesExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'WlWholesaleSalesExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/page/settle/supplier/JointBill.vue